module.exports = __webpack_public_path__ + "media/images/help-center/help-center-background-header-865ff4beeb8310387a6ea79cea7b8e2a.png";